var _rect, _rect2, _rect3, _path, _path2, _line, _line2, _line3, _line4, _path3, _line5, _line6, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkValidInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 4.84082,
    width: 21.9909,
    height: 29.4091,
    rx: 1.25,
    fill: "white",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.94531,
    y: 2.85449,
    width: 13.6,
    height: 3.70909,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.93164,
    y: 3.60449,
    width: 9.62727,
    height: 2.20909,
    rx: 1.10455,
    fill: "white",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7452 1C10.2616 1 10.3028 2.64848 10.5088 3.47273H12.9815C13.1876 2.64848 13.2288 1 11.7452 1Z",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 11.8179L4.94535 12.7452L7.41808 10.2725",
    stroke: "#717070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 11.0088,
    x2: 19.7816,
    y2: 11.0088,
    stroke: "#717070"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 13.4814,
    x2: 19.7816,
    y2: 13.4814,
    stroke: "#717070"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 18.4272,
    x2: 19.7816,
    y2: 18.4272,
    stroke: "#717070"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 20.8999,
    x2: 19.7816,
    y2: 20.8999,
    stroke: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 26.6548L4.94535 27.5821L7.41808 25.1094",
    stroke: "#717070"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 25.8457,
    x2: 19.7816,
    y2: 25.8457,
    stroke: "#717070"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6543,
    y1: 28.3184,
    x2: 19.7816,
    y2: 28.3184,
    stroke: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00054 18.3599L7.00038 21.3599",
    stroke: "#717070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3599L6.99994 18.3599",
    stroke: "#717070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkValidInvoices);
export default __webpack_public_path__ + "static/media/mark-valid-invoices.cc4e273de6944b002d0b1581b2d90a70.svg";
export { ForwardRef as ReactComponent };